import { convertLabelMapToConfig, mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.NoOversizeMaterial`]: 'No Oversize',
      [`${prefix}.SieveMassType`]: 'Oversize Material Treated As',
      [`${prefix}.Sieves.Sieve`]: 'Sieve ID',
      [`${prefix}.Sieves.TareMass`]: 'Tare Mass',
      [`${prefix}.Sieves.TarePlusWetMassRetained`]: 'Tare and Mass Retained',
      [`${prefix}.Sieves.WetMassRetained`]: 'Individual Mass Retained',
    })
  );

export default getLabelConfig;
